import { render } from "./shifts.vue?vue&type=template&id=50baf0fa&scoped=true"
import script from "./shifts.vue?vue&type=script&lang=js"
export * from "./shifts.vue?vue&type=script&lang=js"

import "./shifts.vue?vue&type=style&index=0&id=50baf0fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50baf0fa"]])

export default __exports__